(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.service('dpText', dpText)
		.service('dpHelper', ['$http', '$timeout', dpHelper]);

	function dpText() {
		var _this = this;

		_this.txt = {};

		_this.set = function(texts) {
			_this.txt = texts;
		};

		_this.get = function(key) {
			return _this.txt[key];
		};

		_this.getAll = function() {
			return _this.txt;
		};
	}

	function dpHelper($http, $timeout) {
		var _this = this;
		_this.step = 1;

		_this.refreshPriceData = function(formData, onRefresh) {
			Session.set(formData, null, function() {
				var data = $.param({
					step: _this.step,
				});

				$http.post('/diplomovky/fast_ajax/refreshPriceData', data).then(function(response){
					var priceData = response.data;
					
					if (typeof onRefresh === 'function') {
						onRefresh(priceData);
					}

					PriceTable.setTable(priceData);
				});
			});
		};

		_this.plusCount = function(count) {
			if (isNaN(count)) {
				count = 0;
			}
			
			return parseInt(count) + 1;
		};

		_this.minusCount = function(count, minCount) {
			count = parseInt(count);

			if (count > minCount) {
				count -= 1;
			}

			return count;
		};

		_this.getMinimumCount = function(voucher, minCount) {
			if (voucher && voucher.vouchers && minCount != voucher.vouchers.length) {
				if (voucher.vouchers.length > 0) {
					minCount = voucher.vouchers.length;
				} else {
					minCount = 1;
				}
			}

			return minCount;
		};

		_this.getVoucherData = function(sessionData) {
			var voucherData = null;

			if (sessionData.payment_mode === 'voucher') {
				voucherData = sessionData.voucher;
			}
			if (sessionData.payment_mode === 'fx_voucher') {
				voucherData = sessionData.faxcopy_voucher;
			}
			if (sessionData.payment_mode === 'benefit') {
				voucherData = sessionData.benefit;
			}

			return voucherData;
		};

		_this.getStoreCategoryId = function(binding, processing) {
			var catId = null;

			switch (binding) {
				case 'foilxpress':
					if (processing === 'cover_only') {
						catId = 61;
					} else {
						catId = 62;
					}
					break;

				case 'opus':
					if (processing === 'cover_only') {
						catId = 63;
					} else {
						catId = 64;
					}
					break;

				case 'unibind':
					if (processing === 'cover_only') {
						catId = 65;
					} else {
						catId = 66;
					}
					break;
			}

			return catId;
		};

		_this.refreshSelectpickers = function($scope) {
		    //timeout sa spustí až po renderi viewu
		    $timeout(function() {
		    	if ($scope && $scope.formData) {
		    		var selects = angular.element('select[ng-model]');

		    		angular.forEach(selects, function(select) {
		    			var options = angular.element(select).find('option[value][value!=""]:not(:empty)');
		    			var formDataName = angular.element(select).attr('ng-model').split('.')[1];

		    			var isSelectedValueInOptions = options.parent().find('[value=' + $scope.formData[formDataName] + ']').length > 0;
		    			var isThereDefaultValue = $scope.formData[formDataName] !== undefined;
	
		    			if ((!isThereDefaultValue || !isSelectedValueInOptions) && options.length === 1) {
			    			$scope.formData[formDataName] = options.attr('value');
			    		}
		    		});
		    	}

		    	$timeout(function() {
		    		$('select').selectpicker('refresh');
		    	});
			});
		};

		_this.refreshSelectpicker = function(ngModel, $scope) {
		    //timeout sa spustí až po renderi viewu
		    $timeout(function() {
		    	if ($scope && $scope.formData) {
		    		var formDataName = ngModel.split('.')[1];
		    		var options = angular.element('select[ng-model="' + ngModel + '"] option[value][value!=""]');

		    		if ($scope.formData[formDataName] === undefined && options.length === 1) {
		    			$scope.formData[formDataName] = options.attr('value');
		    		}
		    	}

		    	$timeout(function() {
			    	angular.element('select[ng-model="' + ngModel + '"]').selectpicker('refresh');
				});
			});
		};
	}

}());